import React from 'react';
import classNames from 'classnames/bind';
import { TypographyProps, Typography } from '@mui/material';
import styles from './Title.module.scss';

const CN = 'title';

const cx = classNames.bind(styles);

export const Title: React.FC<TypographyProps> = ({
  children,
  className,
  ...rest
}) => (
  <Typography
    variant='h6'
    className={ cx(CN, className) }
    { ...rest }
  >
    { children }
  </Typography>
);
